export const externalOperatorTags = [
  'ExternalOperatorShippings',
  'ExternalOperatorTimeSlots',
  'ExternalOperatorServices',
  'ExternalOperatorZones',
  'ExternalOperatorCommerces',
  'ExternalOperatorDrivers',
  'ExternalOperatorBatchTransition',
] as const;
